import { Injectable, Pipe } from '@angular/core';
import { Response } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
// tslint:disable-next-line:use-pipe-transform-interface
@Pipe({ name: 'ImageUploadService' })

@Injectable()
export class ImageUploadService {

  constructor(private httpClient: HttpClient) { }

  uploadImage(base64: string, imageName: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/file/uploadImage';
    return this.httpClient.post(url, { Base64Img: base64, ImageName: imageName })
      .map((response: Response) => {
        return response;
      });
  }

  uploadFile(fileList: File[]) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/file/uploadFile';
    let formData: FormData = new FormData();
    for (var i = 0; i < fileList.length; i++) {
      formData.append('fileList', fileList[i]);
    }
    return this.httpClient.post(url, formData)
      .map((response: Response) => {
        return response;
      });
  }

  downloadFile(filename: string, fileurl: string) {
    const url = localStorage.getItem('ApiEndPoint') + '/api/file/downloadFile';
    return this.httpClient.post(url, { FileName: filename, FileUrl: fileurl })
      .map((response: Response) => {
        return response;
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/imageupload.service.ts